import { ButtonsWrapper, ContentButton, ContentButtons, Icon, Label, Wrapper } from "./paragraphs.styles";
import { FontSizeOutlined, PictureOutlined } from "@ant-design/icons";
import { useChapterEditorDataContext } from "contexts/ChapterEditorContext";
import { emptyParagraphDraft, ParagraphEditorDataProvider } from "contexts/ParagraphEditorContext";
import ParagraphEditor from "../Paragraph/paragraph";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { ParagraphType } from "models/wall";
import { createDraftParagraph } from "api/paragraphs";

export default function Paragraphs() {
  const { t } = useTranslation();
  const { draftChapter, updateDraftChapter, setIsSaving } = useChapterEditorDataContext();

  const onCreateParagraph = async (type: ParagraphType) => {
    if (!draftChapter || !draftChapter.uuid) return;
    setIsSaving(true);

    try {
      const res = await createDraftParagraph({
        ...emptyParagraphDraft,
        text: "",
        draft_chapter: draftChapter.uuid,
        type,
      });
      updateDraftChapter({draft_paragraphs: [...(draftChapter.draft_paragraphs || []), res]});
    } catch (e) {
      console.log(e);
    } finally {
      setIsSaving(false);
    }
  }

  if (!draftChapter) return <Wrapper/>;
  return (
    <Wrapper>
      <AnimatePresence>
        {draftChapter.draft_paragraphs?.filter(p => !p.is_deleted).map((p) => {
          if (!draftChapter.uuid) return '';
          return (
            <motion.div
              layout
              initial={{ opacity: 0, y: 50, scale: 0.3 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
              key={p.uuid}
            >
              <ParagraphEditorDataProvider chapterId={draftChapter.uuid} initialDraft={p} >
                <ParagraphEditor />
              </ParagraphEditorDataProvider>
            </motion.div>
          );
        })}
      </AnimatePresence>

      {!!draftChapter?.uuid && (
        <ButtonsWrapper>
          <ContentButtons>
            <ContentButton onClick={() => onCreateParagraph('text')}>
              <Icon><FontSizeOutlined /></Icon>
              <Label>{t('wall.text')}</Label>
            </ContentButton>
            <ContentButton onClick={() => onCreateParagraph('media')}>
              <Icon><PictureOutlined /></Icon>
              <Label>{t('wall.photo')}</Label>
            </ContentButton>
          </ContentButtons>
        </ButtonsWrapper>
      )}


    </Wrapper>
  );
};
